import React, { useEffect, useState } from "react";

import { Box } from "@mui/material";

import { TeamsIntegrationModalMetadataForm } from "../TeamsIntegrationModalMetadataForm";
import { TeamsIntegrationTreeView } from "../TeamsIntegrationTreeView";

import { useTeamsAndChannels } from "@/context/TeamsAndChannelsContext";
import { useTeamsFiles } from "@/hooks/useTeamsFiles";

interface ITeamsIntegrationModalMetadataStepProps {}

export const TeamsIntegrationModalMetadataStep: React.FC<
  ITeamsIntegrationModalMetadataStepProps
> = () => {
  const { getAllSelectedFiles, updateTeamsFile } = useTeamsFiles();
  const { teamsFiles } = useTeamsAndChannels();

  const [fileCategory, setFileCategory] = useState<string>("");
  const [metadata, setMetadata] = useState<string>("");

  const handleFileCategoryChange = (category: string) => {
    setFileCategory(category);

    // Get all files that have selected = true
    const selectedFiles = getAllSelectedFiles();

    // Update the category of all selected files
    for (const file of selectedFiles) {
      const categoryArray = category
        ? [category as "Deloitte data" | "Client data" | "Third-party data"]
        : null;

      updateTeamsFile(file.id, { category: categoryArray });
    }
  };

  const handleMetadataChange = (metadata: string) => {
    setMetadata(metadata);

    // Get all files that have selected = true
    const selectedFiles = getAllSelectedFiles();

    // Update the metadata of all selected files
    for (const file of selectedFiles) {
      updateTeamsFile(file.id, { metadata });
    }
  };
  useEffect(() => {
    const selectedFiles = getAllSelectedFiles();

    if (selectedFiles.length === 0) {
      setFileCategory("");
      setMetadata("");
      return;
    }

    // Validate categories
    const categories = selectedFiles.map((file) => file.category?.[0] ?? "");
    const uniqueCategories = [...new Set(categories)];

    if (uniqueCategories.length === 1) {
      // All have the same category
      setFileCategory(uniqueCategories[0]);
    } else {
      // There are different categories
      setFileCategory("");
    }

    // Validate metadata
    const metadatas = selectedFiles.map((file) => file.metadata ?? "");
    const uniqueMetadatas = [...new Set(metadatas)];

    if (uniqueMetadatas.length === 1) {
      // All have the same metadata
      setMetadata(uniqueMetadatas[0]);
    } else {
      // There are different metadatas
      setMetadata("");
    }
  }, [teamsFiles, getAllSelectedFiles]);
  return (
    <Box display="flex" sx={{ width: "100%" }}>
      <TeamsIntegrationTreeView />
      <TeamsIntegrationModalMetadataForm
        handleFileCategoryChange={handleFileCategoryChange}
        handleMetadataChange={handleMetadataChange}
        fileCategory={fileCategory}
        metadata={metadata}
      />
    </Box>
  );
};
